import { __awaiter } from '../_virtual/_tslib.js';

function getOtpValue() {
    return __awaiter(this, void 0, void 0, function* () {
        if ("OTPCredential" in window) {
            const ac = new AbortController();
            navigator.credentials
                .get({
                otp: { transport: ["sms"] },
                signal: ac.signal
            })
                .then((otp) => {
                console.log(otp, "=========>");
                return otp;
            })
                .catch((err) => {
                return err;
            });
        }
    });
}

export { getOtpValue };
//# sourceMappingURL=getOtpValue.js.map
